<template>
  <div>
    <!-- Categories Section -->
    <div v-if="donorStore.hostPreferences?.categories === null || donorStore.hostPreferences?.categories?.length > 0">
      <div class="field-title">Categories</div>
      <div v-if="donorStore.hostPreferences?.categories === null">
        <Skeletor
          v-for="index in 6"
          height="42px"
          class="skeletonTag"
          width="100px"
          pill
        />
      </div>
      <div
        v-for="(category, index) in donorStore.hostPreferences?.categories || []"
        :key="index"
        class="tag"
        :class="{
          'tag--selected': isSelected(category, 'categories'),
        }"
        @click="toggleSelect(category, 'categories')"
        data-test="category"
      >
        {{ category.longValue }}
      </div>
    </div>

    <!-- Organization Size Section -->
    <div v-if="donorStore.hostPreferences?.orgSizes === null || donorStore.hostPreferences?.orgSizes?.length > 0">
      <div class="field-title">Organization Size</div>
      <div v-if="donorStore.hostPreferences?.orgSizes === null">
        <Skeletor
          v-for="index in 6"
          height="42px"
          class="skeletonTag"
          width="100px"
          pill
        />
      </div>
      <div
        v-for="(orgSize, index) in donorStore.hostPreferences?.orgSizes || []"
        :key="index"
        class="tag"
        :class="{
          'tag--selected': isSelected(orgSize, 'orgSizes'),
        }"
        @click="toggleSelect(orgSize, 'orgSizes')"
        data-test="orgSize"
      >
        {{ orgSize.longValue }}
      </div>
    </div>

    <!-- Areas of Impact Section -->
    <div
      v-if="donorStore.hostPreferences?.areasOfImpact === null || donorStore.hostPreferences?.areasOfImpact?.length > 0"
    >
      <div class="field-title">Areas of Impact</div>
      <div v-if="donorStore.hostPreferences?.areasOfImpact === null">
        <Skeletor
          v-for="index in 6"
          height="42px"
          class="skeletonTag"
          width="100px"
          pill
        />
      </div>
      <div
        v-for="(areaOfImpact, index) in donorStore.hostPreferences?.areasOfImpact || []"
        :key="index"
        class="tag"
        :class="{
          'tag--selected': isSelected(areaOfImpact, 'areasOfImpact'),
        }"
        @click="toggleSelect(areaOfImpact, 'areasOfImpact')"
        data-test="areaOfImpact"
      >
        {{ areaOfImpact.longValue }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDonorStore } from '@/stores/DonorStore.js';

const donorStore = useDonorStore();
const mainColor = donorStore.mainColor;
// Props and emits setup
const props = defineProps({
  localPreferences: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(['update:localPreferences']);

// Function to toggle selection and emit updates
function toggleSelect(tag, type) {
  if (!Array.isArray(props.localPreferences[type])) {
    props.localPreferences[type] = [];
  }

  const index = props.localPreferences[type].findIndex(
    (localTag) => localTag.customLookups_id === tag.customLookups_id,
  );

  if (index >= 0) {
    props.localPreferences[type].splice(index, 1);
  } else {
    props.localPreferences[type].push(tag);
  }

  // Emit the updated localPreferences object
  emit('update:localPreferences', { ...props.localPreferences });
}

// Helper to check if a tag is selected
function isSelected(tag, type) {
  return (
    Array.isArray(props.localPreferences[type]) &&
    props.localPreferences[type].some((localTag) => localTag.customLookups_id === tag.customLookups_id)
  );
}
</script>
<style lang="scss" scoped>
.field-title {
  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
}
.field {
  color: #000;
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tag {
  cursor: pointer;
  display: inline-flex;
  padding: 8px 16px;
  margin: 8px;
  gap: 10px;
  border-radius: 40px;
  border: 1px solid var(--p-primary-500);
  background: var(--White, #fff);
}

.skeletonTag {
  display: inline-flex;
  padding: 8px 16px;
  margin: 8px;
  gap: 10px;
}

.tag--selected {
  background: var(--p-primary-500);
  color: white;
}
</style>
